module.exports = __webpack_public_path__ + "static/img/logo10.c9b8c3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo10.png
// module id = rZGW
// module chunks = 1